import {Navigate, Outlet, useLocation} from "react-router-dom";
import {useAuth} from "./AuthProvider";
import ProtectedLayout from "../layout/ProtectedLayout";

// `bare`: logged-in only, but without the header and footer (the print page).
export const ProtectedRoute = ({bare = false}) => {
    const {isAuthenticated} = useAuth();
    const location = useLocation();

    if (!isAuthenticated) {
        // Remember where the user was headed so login can send them back.
        return <Navigate to="/login" state={{from: location}} replace />;
    }

    return bare ? <Outlet /> : <ProtectedLayout />;
};
